import { render } from "./Honor.vue?vue&type=template&id=f4d6dda6&scoped=true&ts=true"
import script from "./Honor.vue?vue&type=script&lang=ts"
export * from "./Honor.vue?vue&type=script&lang=ts"

import "./Honor.vue?vue&type=style&index=0&id=f4d6dda6&scoped=true&lang=less"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f4d6dda6"]])

export default __exports__